/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Folder16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M6.6 2L8 3.375h5.6c.725 0 1.325.548 1.394 1.243L15 4.75v6.875a1.39 1.39 0 01-1.266 1.369L13.6 13H2.4a1.395 1.395 0 01-1.394-1.243L1 11.625l.007-8.25c0-.712.552-1.302 1.259-1.369L2.4 2h4.2zm-.409 1H2.4a.39.39 0 00-.385.301l-.008.075L2 11.625c0 .175.137.33.32.367L2.4 12h11.2a.4.4 0 00.392-.301l.008-.074V4.75a.387.387 0 00-.32-.367l-.08-.008H7.591L6.191 3zM11.5 6a.5.5 0 110 1h-7a.5.5 0 010-1h7z"
        />
    </AccessibleSVG>
);

export default Folder16;
